// booking/services/bookingApi.ts
import type { Cart } from '../types/booking'
import { BookingItem, ExtraItem, VoucherItem } from './api'
import * as api from './api'
import { instrumentedCall } from './instrumentedApi'
import { CustomerFormFields } from '../stages/CustomerDetails/types'

export async function apiGetSessionsByDate(
  fromDateTime: string,
  toDateTime?: string,
  options: { includeSoldOut?: boolean } = {},
) {
  return instrumentedCall(
    'getSessionsByDate',
    async () => api.getSessionsByDate(fromDateTime, toDateTime, options),
    {
      fromDateTime,
    },
  )
}

export async function apiGetCart(cartId: string): Promise<Cart | null> {
  return instrumentedCall('getCart', async () => (await api.getCart(cartId)) as Cart | null, {
    cartId,
  })
}

export async function apiCreateCart(payload: {
  locale: string
  sessionId?: string
  bookingItems?: BookingItem[]
  extraItems?: ExtraItem[]
}): Promise<Cart | null> {
  return instrumentedCall('createCart', async () => api.createCart(payload))
}

export async function apiCreateVoucherCart(payload: {
  locale: string
  voucherItems: VoucherItem[]
}): Promise<Cart | null> {
  return instrumentedCall('createVoucherCart', async () => api.createVoucherCart(payload))
}

/*export async function apiCreateCart(payload: { locale?: string } = {}): Promise<Cart | null> {
  return instrumentedCall('createCart', async () => api.createCart(payload))
}*/

export async function apiAddToCart(
  cartId: string,
  sessionId: string,
  bookingItems: BookingItem[],
): Promise<Cart | null> {
  return instrumentedCall('addToCart', async () => api.addToCart(cartId, sessionId, bookingItems))
}

export async function apiRefreshCart(cartId: string): Promise<Cart | null> {
  return instrumentedCall('refreshCart', async () => api.refreshCart(cartId), { cartId })
}

export async function apiAddCheckoutData(cartId: string, data: CustomerFormFields) {
  // IMPORTANT: do NOT attach fields to breadcrumbs/extras (PII risk). Only attach the keys.
  const fieldKeys = data ? Object.keys(data) : []
  return instrumentedCall('addCheckoutData', async () => api.addCheckoutData(cartId, data), {
    cartId,
    fieldKeys,
  })
}

export async function apiSetCouponCode(cartId: string, code: string) {
  return instrumentedCall('setCouponCode', async () => api.setCouponCode(cartId, code), {
    cartId,
  })
}

export async function apiApplyVoucher(cartId: string, voucher: string) {
  return instrumentedCall('applyVoucherToCart', async () => api.applyVoucher(cartId, voucher), {
    cartId,
  })
}

export async function apiGetSession(sessionId: string) {
  return instrumentedCall('getSession', async () => api.getSession(sessionId), { sessionId })
}

/*export async function apiGetCartSession(cartId: string): Promise<Session> {
  return instrumentedCall(
    'getCartSession',
    async () => (await api.getCartSession(cartId)) as Session,
    { cartId },
  )
}*/

export async function apiGetCartLog(abandonId: string) {
  return instrumentedCall('getCartLog', async () => api.getCartLog(abandonId), { abandonId })
}
